import type ParcelTemplate from '~/types/ParcelTemplate';

import { ActionKeys } from '~/actions/constants';
import { type ActionTypes } from '~/actions/index';

export type PackagesState = {
  readonly defaultDistanceUnit: string;
  readonly defaultWeightUnit: string;
  readonly parcelTemplate: Maybe<ParcelTemplate>;
  readonly savePackageTemplateModalIsOpen: boolean;
};

const initialState: PackagesState = {
  defaultDistanceUnit: '',
  defaultWeightUnit: '',
  parcelTemplate: null,
  savePackageTemplateModalIsOpen: false,
};

const packagesReducer = (
  state: PackagesState = initialState,
  action: ActionTypes,
): PackagesState => {
  switch (action.type) {
    case ActionKeys.SETTINGS_CLOSE_SAVE_PACKAGE_TEMPLATE_MODAL:
      return {
        ...state,
        parcelTemplate: null,
        savePackageTemplateModalIsOpen: false,
      };
    case ActionKeys.SETTINGS_OPEN_SAVE_PACKAGE_TEMPLATE_MODAL:
      return {
        ...state,
        parcelTemplate: action.parcelTemplate,
        savePackageTemplateModalIsOpen: true,
      };
    case ActionKeys.FETCH_PACKAGE_DEFAULT_UNITS_SUCCESS:
      return {
        ...state,
        defaultDistanceUnit: action.payload.defaultDistanceUnit,
        defaultWeightUnit: action.payload.defaultWeightUnit,
      };
    default:
      return state;
  }
};

export default packagesReducer;
